import { useRecoilValue } from "recoil";
import { authState } from "@/comn/features/recoil";
import { useLogin } from "@/comn/features/authentication/useLogin";
import { Icon } from "@/comn/components";

export const HeaderSignButton = () => {
    const { isSignedIn } = useRecoilValue(authState);
    const { handleLogin, logout } = useLogin();

    return (
        <button
            type="button"
            className="flex items-center justify-center bg-header rounded h-[32px] w-[32px] hover:bg-black/10 transition-colors"
        >
            {!isSignedIn && <Icon icon="login" onClick={handleLogin} />}
            {isSignedIn && <Icon icon="logout" onClick={logout} />}
        </button>
    );
};
